export const ICON_CONVERT_VIRTUAL_DEVICE = ['cm-virtualdevice', 'cm-input-output']
export const ICON_CONVERT_TAPPARELLA = ['cm-tapparella', 'cm-device-tapparella']
export const ICON_CONVERT_LOCK = ['cm-allarme', 'cm-lock']
export const ICON_CONVERT_SOUND = ['cm-audio', 'cm-sound']
export const ICON_CONVERT_CAMERA = ['cm-cameratvcc', 'cm-camera']
export const ICON_CONVERT_LOAD = ['cm-carichi', 'cm-load']
export const ICON_CONVERT_LOAD_2 = ['cm-carichi2', 'cm-load']

export const ICON_CONVERT_AUTOMATICDOOR = ['cm-device-automaticdoor-1', 'cm-device-automaticdoor']
export const ICON_CONVERT_BARRIER = ['cm-device-barrier-0', 'cm-device-barrier']
export const ICON_CONVERT_SLIDINGGATE = ['cm-device-slidinggate-0', 'cm-device-slidinggate']
export const ICON_CONVERT_SWINGGATE = ['cm-device-swinggate-1', 'cm-device-swinggate']
export const ICON_CONVERT_GARAGE = ['cm-device-shutter-0', 'cm-device-garage']
export const ICON_CONVERT_TURNSTILE = ['cm-device-turnstile-1', 'cm-device-turnstile']

export const ICON_CONVERT_DB_BARRIER = ['device-barrier-0', 'cm-device-barrier']
export const ICON_CONVERT_DB_GARAGE = ['garage', 'cm-device-garage']
export const ICON_CONVERT_DB_SLIDINGGATE = ['device-slidinggate-0', 'cm-device-slidinggate']
export const ICON_CONVERT_DB_SWINGGATE = ['device-swinggate-0', 'cm-device-swinggate']
export const ICON_CONVERT_DB_TURNSTILE = ['device-turnstile-0', 'cm-device-turnstile']

// TODO ADD
/*export const ICON_CONVERT_DB_TURNSTILE = ['GatewayDomotic', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['GatewaySecurity', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['gateway-ethernet', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-ipcam', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['termo', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['gateway-gsm', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-subgateway', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['virtualdevice', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-gateway', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['virtual-input', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['virtual-output', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['iors485', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['rbe', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['tapparella', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-mtma', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-xts7ip', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-plxwifi', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-mtmxip', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-xts5', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-xvp', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-xts7', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-industrialclosures', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['termo-gateway', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-lhsa', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-lhsv', 'cm-device-turnstile']
export const ICON_CONVERT_DB_TURNSTILE = ['device-lhsvplus', 'cm-device-turnstile']*/

